import React from "react";
import { getStyles, toAppUrl } from "../../../assets/js/utils/functions";
import { getSizedImage } from "../../../assets/js/utils/utils";
import useScreenSize, { BreakPoint } from "../../hooks/useScreenSize";
import LazyImage from "../../lazy-image";
import { AppBtn } from "../../ui/buttons";
import AnimatedHeaderText from "../commons/animated-header-text";

const CatlogCommunity = () => {
  const { screen } = useScreenSize();

  return (
    <section className="bg-primary-pastel body-padding body-y-padding">
      <div className="container grid-cols-1 grid md:grid-cols-[52%,48%] xl:grid-cols-[58%,42%] hide-for-observer">
        <div className="md:mr-12.5 lg:mr-15 xl:mr-18">
          {/* <h2 className="text-black heading-three font-bold mb-6.25 sm:mb-8 lg:mb-10">Catlog Community 💜</h2> */}
          <AnimatedHeaderText className=" mb-6.25 sm:mb-8 lg:mb-10" series={[["Catlog", "Community", "💜"]]} />
          <p className="sub-text text-black anim-fade-up" style={getStyles({ "--delay": "1.5s" })}>
            We want to help you grow and stay competitive no matter what stage of your business you are in, and we are
            exploring ways to do that beyond our platform.
            <br /> <br />
            One of the ways we’re doing this is through our merchant Community.
            <br />
            <br />
            The catlog community will allow you:
            <br />
            <br />
            <ul className="space-y-2 md:space-y-2.5">
              {communityPerks.map((p, index) => (
                <li className="flex items-start">
                  {/* prettier-ignore */}
                  <svg className="w-4.5 sm:w-5 md:w-5.5 mr-1.5 sm:mr-2 lg:mr-2.5 mt-0.5 md:mt-1 flex-shrink-0" viewBox="0 0 24 24" fill="none">
                    <rect width="24" height="24" rx="12" fill="#39B588"/>
                    <path d="M10.2951 16.5C10.055 16.5 9.82691 16.3995 9.65883 16.2238L6.26113 12.6702C5.91296 12.3061 5.91296 11.7033 6.26113 11.3392C6.6093 10.9751 7.18559 10.9751 7.53377 11.3392L10.2951 14.2272L16.4662 7.77311C16.8144 7.40896 17.3907 7.40896 17.7389 7.77311C18.087 8.13725 18.087 8.73997 17.7389 9.10412L10.9315 16.2238C10.7634 16.3995 10.5353 16.5 10.2951 16.5Z" fill="white"/>
                  </svg>
                  {p}
                </li>
              ))}
            </ul>
          </p>
          <AppBtn
            size="lg"
            className="mt-7.5 sm:mt-10 lg:mt-12.5 anim-word-up"
            style={getStyles({ "--delay": "1.8s", "--from": "15%" })}
            href={toAppUrl("app/sign-up")}
          >
            Get started with Catlog
            {/* prettier-ignore */}
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="ml-2.5 transform transition-all ease-out duration-100 group-hover:translate-x-0.5">
              <path d="M6 0L4.9425 1.0575L9.1275 5.25H0V6.75H9.1275L4.9425 10.9425L6 12L12 6L6 0Z" fill="currentColor" />
            </svg>
          </AppBtn>
        </div>
        <figure className="h-[80vw] sm:h-[70vw] md:h-full w-full overflow-hidden mt-5 sm:mt-7.5 md:mt-0 rounded-15 sm:rounded-20 lg:rounded-30  relative">
          <LazyImage
            src={getSizedImage(
              "https://res.cloudinary.com/catlog/image/upload/v1670478497/front-pages/community.webp",
              { [BreakPoint.xs]: "w_800", default: "w_1200" },
              screen
            )}
            alt="People sitting and smiling - Catlog community"
            className="w-full h-full object-cover object-[27%,0] sm:object-[22%,0] md:object-center image-appear rounded-15 sm:rounded-20 lg:rounded-30 "
            style={getStyles({ "--delay": "0.5s" })}
          />
        </figure>
      </div>
    </section>
  );
};

const communityPerks = [
  "Reach us quickly for support",
  "Get access to exclusive trainings",
  "Learn and get support from other merchants",
];

export default CatlogCommunity;
